import React from 'react';
import styled from '@emotion/styled';

const ATF_VIDEO_URL = 'https://prs.ohou.se/apne2/events/v1-307100170657920.mp4';
const ATF_POSTER_URL = 'https://prs.ohou.se/apne2/events/v1-307101245124673.png';

export function Video(): React.ReactElement {
  return (
    <Wrapper>
      <Player
        preload="metadata"
        loop
        autoPlay
        muted
        controls={false}
        playsInline
        poster={ATF_POSTER_URL}
      >
        <source src={`${ATF_VIDEO_URL}#t=0.5`} type="video/mp4" />
      </Player>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  overflow-x: clip;
`;

const Player = styled.video`
  width: 100%;
  display: block;
  transform: scale(1.02);
`;
